import { Toast } from "flowbite-react";
import Dashboard from "../../common/components/layout/Dashboard";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableCategory from "./components/tables/TableCategory";

function PurchaseCategoryRegister() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableCategory />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default PurchaseCategoryRegister;